var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPizzazzBoard = function SvgPizzazzBoard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "303.97mm",
    height: "45.862mm",
    viewBox: "0 0 303.96823 45.862492",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.9682 -254.09)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 257,
    width: 40,
    height: 40,
    fill: "#e7ded0"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 257,
    width: 40,
    height: 40,
    fill: "#e45339"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 257,
    width: 40,
    height: 40,
    fill: "#e7ded0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 257,
    width: 40,
    height: 40,
    fill: "#e7ded0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 257,
    width: 40,
    height: 40,
    fill: "#f9db0c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 257,
    width: 40,
    height: 40,
    fill: "#e7ded0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 257,
    width: 40,
    height: 40,
    fill: "#e7ded0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.9241 293.45 10.838-33.394 10.838 33.394l-28.414-20.652h35.152",
    fill: "#444",
    strokeWidth: 0.14647
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e45339"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.967 278.65 0.01307 1.5 0.01337 1.5 1.4868-0.75982 1.4868-0.76005-1.4999-0.74019z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.967 272.3 0.01307 1.5 0.01337 1.5 1.4868-0.75982 1.4868-0.76005-1.4999-0.74019z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 19.88 276.87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.967 278.65 0.01307 1.5 0.01337 1.5 1.4868-0.75982 1.4868-0.76005-1.4999-0.74019z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.967 272.3 0.01307 1.5 0.01337 1.5 1.4868-0.75982 1.4868-0.76005-1.4999-0.74019z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 19.999 276.97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.967 278.65 0.01307 1.5 0.01337 1.5 1.4868-0.75982 1.4868-0.76005-1.4999-0.74019z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.967 272.3 0.01307 1.5 0.01337 1.5 1.4868-0.75982 1.4868-0.76005-1.4999-0.74019z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 19.924 277.14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.967 278.65 0.01307 1.5 0.01337 1.5 1.4868-0.75982 1.4868-0.76005-1.4999-0.74019z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.967 272.3 0.01307 1.5 0.01337 1.5 1.4868-0.75982 1.4868-0.76005-1.4999-0.74019z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(172)",
    fill: "#c1eaff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.967 278.65 0.01307 1.5 0.01337 1.5 1.4868-0.75982 1.4868-0.76005-1.4999-0.74019z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.967 272.3 0.01307 1.5 0.01337 1.5 1.4868-0.75982 1.4868-0.76005-1.4999-0.74019z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 19.88 276.87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.967 278.65 0.01307 1.5 0.01337 1.5 1.4868-0.75982 1.4868-0.76005-1.4999-0.74019z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.967 272.3 0.01307 1.5 0.01337 1.5 1.4868-0.75982 1.4868-0.76005-1.4999-0.74019z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 19.999 276.97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.967 278.65 0.01307 1.5 0.01337 1.5 1.4868-0.75982 1.4868-0.76005-1.4999-0.74019z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.967 272.3 0.01307 1.5 0.01337 1.5 1.4868-0.75982 1.4868-0.76005-1.4999-0.74019z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 19.924 277.14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.967 278.65 0.01307 1.5 0.01337 1.5 1.4868-0.75982 1.4868-0.76005-1.4999-0.74019z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.967 272.3 0.01307 1.5 0.01337 1.5 1.4868-0.75982 1.4868-0.76005-1.4999-0.74019z"
  }))), /*#__PURE__*/React.createElement("text", {
    x: 191.83774,
    y: 270.75586,
    fill: "#444444",
    fontFamily: "Roboto",
    fontSize: "6.6108px",
    letterSpacing: "0px",
    strokeWidth: 0.1699,
    textAnchor: "middle",
    wordSpacing: "0px",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 191.83774,
    y: 270.75586
  }, "DOUBLE"), /*#__PURE__*/React.createElement("tspan", {
    x: 191.83774,
    y: 279.34995
  }, "LETTER"), /*#__PURE__*/React.createElement("tspan", {
    x: 191.83774,
    y: 287.94406
  }, "SCORE")))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPizzazzBoard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pizzazzBoard.b8d792da.svg";
export { ForwardRef as ReactComponent };